import CharlesButton from "components/base/Button";
import { Input, Text } from "components/base/Form";
import Page from "components/base/Page";
import { Alert } from "components/base/Toast";
import { useContext, useState } from "react";
import { useParams } from "react-router-dom";
import { v4 } from "uuid";
import { ProductContext } from "./context";
import PackagingView from "./PackagingView";

const ReleaseDetailPage = () => {
  const { products, setProducts } = useContext(ProductContext);
  const { id } = useParams();

  const product = products.find((i) => i.id === id);

  const [state, setState] = useState(product);

  function saveHandler() {
    const updatedProducts = products.map((p) =>
      p.id === product.id ? { ...p, ...state } : p,
    );
    setProducts(updatedProducts);
    Alert("success", "Product saved successfully!");
  }

  function createPkg() {
    const name = window.prompt("Enter packaging name:");
    if (!name) return;

    const packaging = {
      id: v4(),
      name,
      containers: [],
    };
    setState((prevState) => ({
      ...prevState,
      packaging: [...(prevState.packaging || []), packaging],
    }));
  }

  function deletePkg(pkgId) {
    setState((prevState) => ({
      ...prevState,
      packaging: prevState.packaging.filter((p) => p.id !== pkgId),
    }));
  }

  function updatePkg(pkg, values) {
    console.log("updatePkg", pkg, values);
    const updatedPackaging = state.packaging.map((p) => {
      if (p.id === pkg.id) {
        return { ...p, ...values };
      }
      return p;
    });

    setState((prevState) => ({
      ...prevState,
      packaging: updatedPackaging,
    }));
  }

  console.log("state", state);

  return (
    <Page
      title={`${product.name} Version ${product.version}`}
      backTo="./.."
      rightButtons={
        <div>
          <CharlesButton onClick={saveHandler}>Save</CharlesButton>
        </div>
      }
    >
      <div className="text-sm grid grid-cols-12 gap-6 p-6">
        <div className="col-span-6 space-y-6">
          <div className="card">
            <h3>Product Information</h3>

            <div className="mt-4">
              <h5>Description</h5>
              <div className="mt-2">
                <Text
                  value={state.description}
                  onChange={(e) =>
                    setState({ ...state, description: e.target.value })
                  }
                />
              </div>
            </div>

            <hr />

            <div>
              <h5>Dimesion</h5>
              <div className="mt-2 -mx-2">
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <label>Size: </label>
                      </td>
                      <td className="w-full">
                        <Input
                          value={state.name}
                          onChange={(e) =>
                            setState({ ...state, name: e.target.value })
                          }
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label htmlFor="">Weight: </label>
                      </td>
                      <td>
                        <Input
                          value={state.weight}
                          onChange={(e) =>
                            setState({ ...state, weight: e.target.value })
                          }
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label htmlFor="">Remark: </label>
                      </td>
                      <td>
                        <Text
                          value={state.dimensionRemark}
                          onChange={(e) =>
                            setState({
                              ...state,
                              dimensionRemark: e.target.value,
                            })
                          }
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <hr />

            <div>
              <h5>Production</h5>
              <div className="mt-2 -mx-2">
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <label>Pantone: </label>
                      </td>
                      <td className="w-full">
                        <Input
                          value={state.name}
                          onChange={(e) =>
                            setState({ ...state, name: e.target.value })
                          }
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label htmlFor="">Materials: </label>
                      </td>
                      <td>
                        <Input
                          value={state.weight}
                          onChange={(e) =>
                            setState({ ...state, weight: e.target.value })
                          }
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label htmlFor="">Printing Method: </label>
                      </td>
                      <td>
                        <Input
                          value={state.weight}
                          onChange={(e) =>
                            setState({ ...state, weight: e.target.value })
                          }
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <hr />

            <div>
              <h5>Compliance</h5>
              <div className="mt-2 -mx-2">
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <label>Age Grading: </label>
                      </td>
                      <td className="w-full">
                        <Input
                          value={state.name}
                          onChange={(e) =>
                            setState({ ...state, name: e.target.value })
                          }
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label>Warnings: </label>
                      </td>
                      <td className="w-full">
                        <Input
                          value={state.name}
                          onChange={(e) =>
                            setState({ ...state, name: e.target.value })
                          }
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label htmlFor="">Test Reports: </label>
                      </td>
                      <td>
                        <Input
                          value={state.weight}
                          onChange={(e) =>
                            setState({ ...state, weight: e.target.value })
                          }
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div className="col-span-6 space-y-6">
          <div className="card">
            <h3>Packaging</h3>
            <div className="mt-4">
              {state.packaging && state.packaging.length > 0 ? (
                <div className="space-y-8 mt-8">
                  {state.packaging.map((i) => (
                    <PackagingView
                      key={i.id}
                      pkg={i}
                      updatePkg={(values) => updatePkg(i, values)}
                      deletePkg={() => deletePkg(i.id)}
                    />
                  ))}
                </div>
              ) : null}

              <hr />
              <CharlesButton onClick={createPkg}>+ Packaging</CharlesButton>
            </div>
          </div>
        </div>
      </div>
    </Page>
  );
};

export default ReleaseDetailPage;
